import React from 'react';
import WelcomeToYalango from '../../components/guides/WelcomeToYalango';

const Onboarding = () => {
  return (
    <>
        <div className="min-h-screen w-full">
            <WelcomeToYalango />
        </div>
    </>
  )
}

export default Onboarding